import showOwnads from '../components/ownads';
import toaster from '../components/toaster';

import setupGlobals from '../components/globals';
import setupHeader from '../components/header';
import setupCopyText from '../components/copy-text';
import setupPaywall from '../components/paywall';
import setupMasonyGrid from '../components/masonry-grid';
import setupLightbox from '../components/lightbox';
import setupTriggerBeeDataLayer from '../components/trigger-bee-data-layer';
import setupDropdown from '../components/dropdown';
import setupGallery from '../components/gallery';
import setupCarousels from '../components/carousel';
import setupFiniteScroll from '../components/finite-scroll';
import setupAdform from '../components/adform';
import setupCookieNotice from '../components/cookie-notice';
import setupIframeCookieNotice from '../components/iframe-cookie-notice';
import setuptakeoverAd from '../components/takeover-ad';
import setupCommentCount from '../components/comment-count';
import setupPopularPosts from '../components/popular-posts';
import splxPagination from '../components/splx-pagination';
import searchFAQ from '../components/faq';
import calculateReadingTime from '../components/reading-time';

export default {
  init() {
    // JavaScript to be fired on all pages
    const scope = this;

    setupGlobals();
    scope.uiActions();
    showOwnads();
    window.toaster = toaster;

    $('.gf_readonly input, .gf_readonly textarea').attr('readonly', 'readonly');
  },

  uiActions() {
    setupCopyText();
    setupTriggerBeeDataLayer();
    setupHeader();
    setupPaywall();
    setupDropdown();
    setupMasonyGrid();
    setupLightbox();
    setupGallery();
    setupCarousels();
    setupFiniteScroll();
    setupAdform();
    setupCookieNotice();
    setupIframeCookieNotice();
    setuptakeoverAd();
    setupCommentCount();
    setupPopularPosts();
    splxPagination();
    searchFAQ();
    calculateReadingTime();
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js